exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert {\n  padding: 20px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n  .alert-danger {\n    color: #C71720;\n    background-color: #FFDFE1;\n    border-color: #FFDFE1; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/alert/alert.component.scss
// module id = ../../../../../src/app/shared/alert/alert.component.scss
// module chunks = main